import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18.947",
  height: "20",
  fill: "none",
  viewBox: "3641 391 18.947 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3641 411v-2.105h12.632V411zm5.948-5.105-5.948-5.948 2.211-2.263 6 5.948zm6.684-6.684-5.947-6 2.263-2.211 5.947 5.947zm4.842 10.736-13.737-13.736 1.474-1.474 13.737 13.737z",
      class: "fills",
      style: {"fill":"#1f7eff","fill-opacity":"1"}
    }, null, -1)
  ]))]))
}
export default { render: render }